import { ProductsService } from 'src/app/services/products.service';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { ListColumn } from 'src/app/models/list-column.model';
import { EndCustomerService } from 'src/app/services/end-customer.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { AllProductService } from 'src/app/services/shared/product-settings/all-products.service';
import { CategoryService } from 'src/app/services/shared/product-settings/category.service';
import { SpecificationService } from 'src/app/services/shared/product-settings/specification.service';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { ProductStorageService } from 'src/app/services/products-storage.service';
import { Observable } from 'rxjs';
interface BulkProduct {
  id:string;
  productName: string;
  categoryId: string;
  categoryName: string;
  productSku: string;
  description: string;
  releaseDate: string;
  soldTillNow: string;
  video: string;
  specifications: string;
  tags: string[];
  images: string[];
  type: string;
  validationErrors: string[];
  specification: any;
}

@Component({
  selector: 'app-bulk-upload',
  templateUrl: './bulk-upload.component.html',
  styleUrls: ['./bulk-upload.component.scss']
})
export class BulkUploadComponent implements OnInit {

  @ViewChild('excelUploadDialog') excelUploadDialog!: TemplateRef<any>;

  dialogRef!: MatDialogRef<any>;
  selectedExcelFile: any | null = null;
  excelError: string = '';
  productForm: FormGroup;
  selectedImages: string[] = [];

  imageError: string | null = null;

  products: BulkProduct[] = [];
  filteredProducts: BulkProduct[] = [];
  totalEntries: number = 0;
  page: number = 0;
  pageSize: number = 10;
  failedCount: number = 0;
  sucessCount: number = 0;
  failureProducts: any[] = [];

  searchKeyword: string = '';
  productNameExists: boolean = false;
  productNameErrorMessage: string = '';
  categoryInputControl = new FormControl('');
  categories: any[] = [];
  filteredCategories: any[] = [];
  columns: ListColumn[] = [
    { name: 'Sr.no', property: 'sNo', visible: true, isModelProperty: false },
    { name: 'Product Name', property: 'productName', visible: true, isModelProperty: true, isText: true },
    { name: 'Category', property: 'categoryName', visible: true, isModelProperty: true, isText: true },
    { name: 'Specifications', property: 'specifications', visible: true, isModelProperty: true, isText: true },
    { name: 'Actions', property: 'action', visible: true, isModelProperty: true  ,hasAction: true,
      actions:[
              {imageUrl:'assets/images/bin.svg', isImage:true, actionType:MweConstants.deleteAction}]
    },
  ] as ListColumn[];
  

  
  specifications: any[] = [];
  selectedSpecifications: string[] = [];
  specInputControl = new FormControl('');
  localProducts$: Observable<any[]>=new Observable<any[]>();

  constructor(private fb: FormBuilder, 
    private localStorageService: LocalStorageService, 
    private dialog: MatDialog,
    private productsService: ProductsService,
    private categoryService: CategoryService,
    private productStorageService: ProductStorageService,
    private endCustomerService: EndCustomerService,
    private specificationservice: SpecificationService,
    private allProductService: AllProductService,
  ) {
      this.productForm = this.fb.group({
        productName: ['', Validators.required],
        categoryId: [''],
        categoryName: ['', Validators.required],
        specifications: ['', Validators.required],
        specification: this.fb.array([]),
      });
      
    
  }

ngOnInit(): void {
  this.filteredProducts = [...this.products];    
  this.totalEntries = this.filteredProducts.length;

  this.getAllSpecifications();
  this.getChildCategories();

  this.localProducts$ = this.productStorageService.getAllLocalProducts();

  this.productStorageService.getAllLocalProducts().subscribe(data => {
    const localProducts = data.map((product: any) => ({
      id: product?.id ?? '',
      productName: product?.data?.productName ?? '',
      categoryId: product?.data?.categoryId ?? '',
      categoryName: product?.data?.categoryName ?? '',
      specifications: product?.data?.specifications ?? '',
      images: product?.data?.images ?? [],
      type: product?.data?.type ?? '',
      validationErrors: product?.data?.validationErrors ?? [],
      description: product?.data?.description ?? '',
      releaseDate: product?.data?.releaseDate ?? '',
      soldTillNow: product?.data?.soldTillNow ?? '',
      video: product?.data?.video ?? '',
      productSku: product?.data?.productSku ?? '',
      tags: product?.data?.tags ?? [],
      specification: product?.data?.specification ?? []
    }));

    this.filteredProducts = localProducts;
    this.products = [...localProducts];
    this.totalEntries = this.filteredProducts.length;
  });
}

onSpecInputBlur() {
  if (this.selectedSpecifications.length > 0) {
    this.specInputControl.setErrors(null); 
    this.specInputControl.markAsUntouched(); 
    return;
  }

  if (!this.specInputControl.value || this.specInputControl.value.trim() === '') {
    this.specInputControl.setErrors({ required: true });
    this.specInputControl.markAsTouched(); 
  } else {
    this.specInputControl.setErrors(null); 
  }
}

  onFilesSelected(event: any): void {
    const input = event.target as HTMLInputElement;
    event.preventDefault();

    const files: any =  event.target.files;
    if (!files?.length) return;

    Array.from(files).forEach((file: any) => {
      if (!file.type.startsWith('image/')) {
        Swal.fire({ icon: 'error', title: 'Invalid File', text: 'Only image files are allowed.' });
        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        Swal.fire({ icon: 'error', title: 'File Size Exceeded', text: 'File should not exceed 10MB.' });
        return;
      }

      const formData = new FormData();
      formData.append('file', file);
      const randomKey = Math.floor(Math.random() * 10) + 1;
      formData.append('destinationKey', randomKey + '');

      // this.isLoading = true;
      this.endCustomerService.executePostRequestForAuth(MweConstants.uploadFile, formData).subscribe(
        (res: any) => {
          if (res?.data) {
            input.value = '';
            this.selectedImages.push(res.data);
          }
          // this.isLoading = false;
        },
        error => {
          // this.isLoading = false;
          input.value = '';
          Swal.fire({ icon: 'error', title: 'Upload Failed', text: 'Something went wrong while uploading image.' });
        }
      );
    });
  }

    selectedAction(event:any){
    switch (event.action) {
      case MweConstants.deleteAction:
        this.removeProduct(event.row);
        break;
      default:
        break;
    }
  }

  removeImage(index: number, event: Event): void {
    event.stopPropagation();
    this.selectedImages.splice(index, 1);
  }
  filteredSpecifications: any[] = [];
  onSpecificationChange(event: any): void {
      
    const searchTerm = event.target.value.toLowerCase();
    if (searchTerm) {
      this.filteredSpecifications = this.specifications.filter(spec =>
        spec.name.toLowerCase().includes(searchTerm)
      );
    } else {
      this.filteredSpecifications = this.specifications;
    }
  }
  onCategorySelected(categoryName: any): void {
    const selected =categoryName;
    if (selected) {
      this.productForm.patchValue({
        categoryId: selected.id,
        categoryName: selected.name
      });
    }
  }
  selectCategoryFromInput(): void {
    const typed = this.categoryInputControl.value?.toLowerCase() || '';
    const match = this.categories.find(c => c.name.toLowerCase() === typed);
    if (match) this.onCategorySelected(match);
  }
  
  onCategoryInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const searchTerm = inputElement.value.toLowerCase();
    this.filteredCategories = this.categories.filter(category =>
      category.name.toLowerCase().includes(searchTerm)
    );
  }
  showpagination: boolean = false;
  
  addSpecificationFromInput(): void {
    const value = this.specInputControl.value?.trim();
    if (value && !this.selectedSpecifications.includes(value)) {
      this.selectedSpecifications.push(value);
      this.productForm.get('specifications')?.setValue(this.selectedSpecifications);
      this.productForm.get('specification')?.patchValue([{name: value, type: ''}]);
      
    }
    this.specInputControl.setValue('');
  }
  removeSpecification(spec: string): void {
    const index = this.selectedSpecifications.indexOf(spec);
    if (index >= 0) {
      this.selectedSpecifications.splice(index, 1);
      this.productForm.get('specifications')?.setValue(this.selectedSpecifications);
    }
  }
validateCategoryInput() {
  const control = this.productForm.get('categoryName');
  if (!control?.value?.trim()) {
    this,this.productForm.get('categoryName')?.setErrors({ required: true }); 
  }
}

  onSpecificationSelected(specification:any): void {
   
    const selected = specification.name;
    
    if (!this.selectedSpecifications.includes(selected)) {
      this.selectedSpecifications.push(selected);
      this.productForm.get('specifications')?.setValue(this.selectedSpecifications);
      const specArray = this.productForm.get('specification') as FormArray;
      specArray.push(this.fb.group({
        name: specification.name,
        type: specification.type
      }));
          }
    this.specInputControl.setValue('');
  }
  onPageChanged(event: any): void {
    this.page = event.pageIndex;
    this.pageSize = event.pageSize; 
    this.applyPagination();
  }

  applyPagination(): void {
    const startIndex = this.page * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.filteredProducts = this.products.slice(startIndex, endIndex);
    
  }  

  private saveProductOffline(product: BulkProduct): void {
    this.productStorageService.saveLocalProduct(product)
      .then(() => {

      })
      .catch((error) => {
        console.error('Failed to save product locally:', error);
      });
  }

clearAllProducts() {
  this.productStorageService.clearAll().then(() => {
  });
}

 addProduct(): void {
  const productName=this.productForm.get('productName')?.value?.trim();
 
  const existingProduct = this.products.find(p => p.productName === productName);
  if (existingProduct) {
    Swal.fire({
      icon: 'error',
      title: 'Product Already Exists',
      text: `The product name '${productName}' is already in the list. Please enter a unique name.`
    });
    return;
  }
    if (this.productForm.invalid && this.selectedImages.length === 0) {
      if (this.selectedImages.length === 0) {
        this.imageError = 'At least one image is required';
      } else {
        this.imageError = null;
      }
      
      Swal.fire({
        icon: 'warning',
        title: 'Form Incomplete',
        text: 'Please fill all required fields and add at least one image.'
      });
      
      return;
    }
    const newProduct: BulkProduct = {
      ...this.productForm.value,
      images: this.selectedImages
    };

    
    
    this.saveProductOffline(newProduct);
    this.products.unshift(newProduct);
    this.totalEntries=this.products.length;
    
    this.applyFilter();
    this.resetForm();    
  }

  resetForm(): void {
    this.productForm.reset();
    this.selectedImages = [];
    this.selectedSpecifications = [];
    this.specInputControl.setValue('');
    this.categoryInputControl.setValue('');
    this.imageError = null;
    this.productNameExists = false;
    this.productNameErrorMessage = '';
  

    this.filteredSpecifications = [];
    this.filteredCategories = [];  // important
    this.filteredSpecifications = this.specifications;
    this.filteredCategories = this.categories;
    Object.keys(this.productForm.controls).forEach(key => {
      const control = this.productForm.get(key);
      if (control) {
        control.markAsPristine();
        control.markAsUntouched();
        control.setErrors(null);
      }
    });
  }
  
  checkProductName(): void {
    const productName = this.productForm.get('productName')?.value?.trim();
    if(!productName){
      this.productNameErrorMessage = 'Product name is required.';
      this.productForm.get('productName')?.setErrors({ required: true });
      this.productForm.get('productName')?.markAsTouched();
      return
    }
    const oemId = this.localStorageService.getItem('oemId');

    let productId = ''; 
  
    if (productName) {
      this.allProductService.checkProductNameExists(productName, oemId, productId).subscribe(
        (res) => {
          this.productNameExists = false;
          this.productNameErrorMessage = '';
          const control = this.productForm.get('productName');
          if (control) {
            control.setErrors(null);
          }
        },
        (err) => {
          this.productNameExists = true;
          this.productNameErrorMessage = 'Product name already exists';
          const control = this.productForm.get('productName');
          if (control) {
            control.setErrors({ productExists: true });
            control.markAsTouched();
          }
        }
      );
    }
  }
  

  removeProduct(row: any): void {
    this.products = this.products.filter(product =>
      !(product.productName === row.productName && product.categoryId === row.categoryId)
    );
    this.applyFilter();
     this.productStorageService.getAllLocalProducts().subscribe(data => {
    const matching = data.find(item =>
      item.data.productName === row.productName &&
      item.data.categoryId === row.categoryId
    );
 
    if (matching) {
      this.productStorageService.deleteLocalProduct(matching.id).then(() => {
      });
    }
  });
 
  }


  searchTerm(event: Event): void {
    const element = event.target as HTMLInputElement;
    this.searchKeyword = element.value;
    this.applyFilter();
  }

  clearSearch(): void {
    this.searchKeyword = '';
    this.applyFilter();
  }

  applyFilter(): void {
    
    this.filteredProducts = [...this.products];
    const keyword = this.searchKeyword?.trim().toLowerCase();
    if (!keyword) {
      this.filteredProducts = [...this.products];
      this.totalEntries=this.filteredProducts.length;
      this.applyPagination(); 
      return;
    }
   

    this.filteredProducts = this.products.filter(product =>
      product.productName.toLowerCase().includes(keyword) ||
      product.specifications.toLowerCase().includes(keyword)
    );
  }

  getAllSpecifications() {
    this.specificationservice.getAllSpecifications().subscribe({
      next: (response) => {
        if(response.data.length > 0) {
          this.filteredSpecifications = response.data.sort((a, b) => a.name.localeCompare(b.name));
          const existingData = this.filteredSpecifications;
          this.specifications = existingData.map(data => ({
            id: data.id,
            name: data.name,
            type: data.type,
            measureRelation: data.measureRelation
          }));
         
         
        }     
      },
      
    });
  }
 openExcelUploadDialog(): void {
    this.selectedExcelFile = null;
    this.excelError = '';
    this.dialogRef = this.dialog.open(this.excelUploadDialog, {
      width: '400px',
    });

    this.dialogRef.afterClosed().subscribe(result => {
      
    })

  }

  onExcelFileSelected(event: Event): void {
    
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file && (file.name.endsWith('.xlsx') || file.name.endsWith('.xls'))) {
      this.selectedExcelFile = file;
      this.excelError = '';
    } else {
      this.selectedExcelFile = null;
      this.excelError = 'Only Excel files (.xlsx, .xls) are allowed.';
    }
  }

createPayload(products: any[]): any[] {
  return products.map(product => {
    const specificationNames = product.specifications?.map((spec: any) => spec.name).join(',') || '';

    return {
      id: product.id || '',
      productName: product.productName || '',
      categoryId: product.categoryId || '',
      categoryName: product.categoryName || '',
      productSku: product.productSku || '',
      description: product.description || '',
      releaseDate: product.releaseDate || '',
      soldTillNow: product.soldTillNow?.toString() || '0',
      video: product.video || '',
      specifications: specificationNames,
      tags: product.tags || [],
      images: product.images || [],
      type: product.type || '',
      specification: product.specifications || [],
      validationErrors: Array.isArray(product.validationErrors)
        ? product.validationErrors
        : (typeof product.validationErrors === 'string'
            ? [product.validationErrors]
            : [])
    };
  });
}





 submitExcel(): void {
  if (!this.selectedExcelFile) return;

  const userId = this.localStorageService.getItem('userId');
  const oemID = this.localStorageService.getItem('oemId');

  this.productsService.bulkUpload(userId, oemID, this.selectedExcelFile).subscribe((res: any) => {
    this.failureProducts = res?.data?.failureProducts || [];
    
    this.failedCount = res?.data?.failureCount;
    this.sucessCount = res?.data?.successCount;

    // Update filteredProducts only with failed entries (if needed)
    this.products = this.createPayload(this.failureProducts);

    Swal.fire({
      title: 'Upload Summary',
      icon: this.failedCount > 0 ? 'warning' : 'success',
      html: `
        <p><strong>Successfully Uploaded:</strong> ${this.sucessCount}</p>
        <p><strong>Failed to Upload:</strong> ${this.failedCount}</p>
        ${this.failedCount > 0 ? '<p>See below for failed entries.</p>' : ''}
      `,
      confirmButtonText: 'OK'
    });

    this.columns.push(
      { name: 'Reason for Failure', property: 'validationErrors', visible: true, isModelProperty: true, isText: true }, 
    )

    this.applyFilter();
    this.clearAllProducts();
    this.dialogRef.close();
  });
}

  getChildCategories(){
    this.categoryService.getChildCategories().subscribe({
      next: (response) => {
        if(response.data.length > 0) {
          this.categories = response.data;
          this.filteredCategories = this.categories;
        }
      },
    });
  }

  downloadTemplateConformation() {
     if(this.filteredProducts.length == 0) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please enter at least one product detail'
      });
      return;
    }
  Swal.fire({
    title: 'Download Product Template',
    text: 'The template will include all currently entered fields. Please do not modify existing data in the exported file.',
    icon: 'info',
    showCancelButton: true,
    confirmButtonText: 'Download',
    cancelButtonText: 'Cancel',
  }).then((result) => {
    if (result.isConfirmed) {
      this.downloadTemplate();
    }
  });

  }
  downloadTemplate() {

    const product_details_data = [
      ['Product Name*', 'Product SKU*', 'Category Name*', 'Category ID*', 'Release Date(yyyy-mm-dd)*', 'Description*', 'Tags', 'Sold Till Now*', 'Video', 'Images*'],
    ];
  
    const specifications_data = [
      ['Product Name', 'Specification Name', 'Specification Type', 'From Value', 'To Value(Optional)', 'Unit'],
    ];
  
    this.products.forEach((product: any) => {
      
      let products_tmp = ['', '', '', '', '', '', '', '', '', ''];
      products_tmp[0] = product?.productName || '';
      products_tmp[1] = product?.productSku || '';
      products_tmp[2] = product?.categoryName || '';
      products_tmp[3] = product?.categoryId || '';
      products_tmp[4] = product?.releaseDate || '';
      products_tmp[5] = product?.description || '';
      products_tmp[6] = product?.tags?.join(',') || '';
      products_tmp[7] = product?.soldTillNow || '';
      products_tmp[8] = product?.video || '';
  
      const images = product.images.join(',');
      products_tmp[9] = images;
  
      product_details_data.push(products_tmp);      

      if (product.specification) {
        product.specification.forEach((spec: any) => {
          if (spec.name) {
            let specifications_tmp = ['', '', '', '', ''];
            specifications_tmp[0] = product?.productName || '';
            specifications_tmp[1] = spec?.name || '';
            specifications_tmp[2] = spec?.type || '';
            specifications_tmp[3] = spec?.fromValue || '';
            specifications_tmp[4] = spec?.toValue || '';
            specifications_tmp[5] = spec?.fromUnit || '';
            specifications_data.push(specifications_tmp);
          }
        });
      }
    });
  
    const getColumnWidths = (data: any[][], hiddenColumns: string[]) => {
      const headers = data[0];
      const colWidths: { wch: number, hidden?: boolean }[] = [];
  
      headers.forEach((header, colIndex) => {
        let maxLen = header.length;
        for (let row = 1; row < data.length; row++) {
          const cell = data[row][colIndex];
          if (cell) {
            maxLen = Math.max(maxLen, String(cell).length);
          }
        }
  
        const shouldHide = hiddenColumns.includes(header);
        colWidths.push({ wch: maxLen + 2, hidden: shouldHide });
      });
  
      return colWidths;
    };
  
    // Columns to hide by their header names
    const hiddenProductColumns: string[] = ["Category ID*"];
    const hiddenSpecColumns: string[] = [];
  
    const productSheet = XLSX.utils.aoa_to_sheet(product_details_data);
    productSheet['!cols'] = getColumnWidths(product_details_data, hiddenProductColumns);
  
    const specSheet = XLSX.utils.aoa_to_sheet(specifications_data);
    specSheet['!cols'] = getColumnWidths(specifications_data, hiddenSpecColumns);
  
    const workbook: XLSX.WorkBook = {
      Sheets: {
        'Product Details': productSheet,
        'Specifications': specSheet
      },
      SheetNames: ['Product Details', 'Specifications']
    };
  
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = URL.createObjectURL(blob);
  
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'product_template.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  

}
